/* eslint-disable linebreak-style */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable no-param-reassign */
import { ChatCompletionRequestMessageRoleEnum } from 'openai';
import { ChatRole, useTextCompletion, ChatMessage as ChatMessageDto } from '../Repository/TextCompletion';
import { LLMModel } from '../Components/Contexts/LLMSettingContext';
import { useTestSetting } from './TestSettingContext';

export const botName = process.env.REACT_APP_BOT_NAME;

declare interface Message {
  content: string;
  sender: string;
}

function createMessage({
  content = '',
  mine = true,
}) {
  return {
    content,
    sender: mine ? 'user' : botName,
  } as Message;
}

const history: Message[] = [];

export const useMockUser = () => {
  // use local model parameter temporarily
  const {
    mockUserTemperature,
    mockUserMaxTokens,
    mockUserPrompt,
    mockUserModel,
    mockUserDeployment,
    mockUserIgnoreDefaultFewShotExamples,
  } = useTestSetting();

  let messages = history;
  const { getChatCompletion } = useTextCompletion();

  const setTopic = async (topic: string) => {
    topic = topic.replace(/\n/g, '<br>');
    const msg = createMessage({ content: topic, mine: false });
    messages = [msg];
  };

  const sendMessage = async (content: string) => {
    content = content.replace(/\n/g, '<br>');
    const msg = createMessage({ content });
    const newMessages = messages.concat(msg);
    messages = newMessages;

    const messageParam = newMessages.map((msg) => ({
      role: (msg as Message).sender === botName ? 'assistant' : 'user' as ChatCompletionRequestMessageRoleEnum,
      content: (msg as Message).content || '',
    }));

    let result;

    if (mockUserModel === LLMModel.Gpt35Turbo) {
      const systemMessages = mockUserPrompt ? [{
        Role: ChatRole.System,
        Content: mockUserPrompt,
      } as ChatMessageDto] : [];
      result = await getChatCompletion(
        '',
        systemMessages.concat(messageParam.map((msg) => ({
          Role: msg.role === 'assistant' ? ChatRole.Assistant : ChatRole.User,
          Content: msg.content,
        } as ChatMessageDto))),
        mockUserMaxTokens,
        mockUserTemperature,
        mockUserIgnoreDefaultFewShotExamples,
        mockUserModel,
        mockUserDeployment,
        '',
      );
    }

    // TODO, define some rules like format checking

    const formattedResContent = (result ?? '').replace(/^(\n|<br>)+|(\n|<br>)+$/g, '').replace(/[\n]+/g, '<br><br>');

    messages = newMessages.concat([
      createMessage({ content: formattedResContent, mine: false }),
    ]);

    return formattedResContent;
  };

  const clearHistory = () => {
    messages = history;
  };

  return {
    setTopic,
    sendMessage,
    clearHistory,
  };
};
